import styled from 'styled-components'
import { Modal } from '@dsny/dsny-component-library'

export const StyledModal = styled(Modal).attrs(
  ({ theme, $isMobile, containerStyles }) => ({
    containerStyles: {
      background: theme.colors.neutralW20,
      border: `1px solid ${theme.colors.neutralW30}`,
      height: 'auto',
      width: $isMobile ? '100%' : '676px',
      ...containerStyles
    }
  })
)``
